/* @flow */
import { rem } from 'polished';
import { hoverSelector } from 'src/shared/app/base/style/token/selector';
import { fadeDuration } from '@braindate/ui/lib/token/animation';
import { baseFontSize } from '@braindate/ui/lib/token/typography';
import { topAppBarElevation } from 'src/shared/app/base/style/token/elevation';
import { lap } from '@braindate/ui/lib/token/mediaQuery';
import { horizontalSmallDeviceBreakpoint } from 'src/shared/app/base/style/util/responsive';

import type { ThemeFunction } from 'src/shared/app/base/types/themeTypes';

export default {
  root: {
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    height: 88,
    zIndex: topAppBarElevation,
    borderBottom: ({ theme }: ThemeFunction) =>
      `0.5px solid ${theme.accentColor}`,
    backgroundColor: ({ theme }: ThemeFunction) => theme.colorBase,
    transition: 'top 0.2s',
  },
  rootScroll: {
    [horizontalSmallDeviceBreakpoint]: {
      top: -88,
    },
  },
  inner: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  nav: {
    display: 'none',

    [lap]: {
      display: 'flex',
    },
  },
  username: {
    marginTop: 4,
    display: 'flex',
    alignItems: 'center',
    color: 'inherit',

    '& svg': {
      marginLeft: 8,
    },
  },
  createTopicButon: {
    [hoverSelector]: {
      '& svg': {
        border: ({ theme }: ThemeFunction) => `1.5px solid ${theme.colorBase}`,
      },
    },
  },
  createTopicButtonContainer: {
    display: 'none',
    [lap]: {
      display: 'block',
      // Setting a min width because the container can be empty, but needs to have a width anyway.
      minWidth: 132,
    },
    '& button': {
      fontWeight: 900,
    },
  },
  createTopicButtonIcon: {
    width: 14,
    height: 14,
    marginRight: 10,
    fontSize: rem(6, baseFontSize),
    border: ({ theme }: ThemeFunction) => `1.5px solid ${theme.accentColor}`,
    borderRadius: '50%',
    padding: 1.5,
  },
  right: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  helpButton: {
    marginRight: 10,
    [lap]: {
      display: 'none',
    },
  },
  avatar: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    transition: `${fadeDuration} ease-out`,
  },
  avatarActive: {
    outline: ({ theme }: ThemeFunction) => `2px solid ${theme.accentColor}`,
  },
  notifications: {
    position: 'relative',
    [lap]: {
      display: 'none',
    },
  },
  badge: {
    position: 'absolute',
    top: 4,
    right: 4,
    border: ({ theme }: ThemeFunction) => `1px solid ${theme.colorBase}`,
  },
  icon: {
    width: '35px !important',
    height: '35px !important',
    borderRadius: '50%',
    padding: 6,
    color: ({ theme }: ThemeFunction) => theme.accentColor,
    backgroundColor: ({ theme }: ThemeFunction) =>
      theme.calendarDisableButtonBackgroundColor,
  },
  profileMenu: {
    display: 'flex',
    alignItems: 'center',

    '& svg': {
      marginLeft: 3,
    },
  },
};
